import React, { useState } from 'react';
import BreadCrumb from '../../components/template/BreadCrumb';
import Header from '../../components/template/Header';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import Spinner from '../../components/layout/Spinner';
import PackagetreatmentForm from '../../components/packagetreatments/PackagetreatmentForm';
import { convertToFormData } from '../../shared/upload';
import {
  initialValues,
  inputFields,
  PAGE_TITLE,
  PAGE_SINGLE_TITLE,
  LINK_URL,
} from '../../shared/enums/packagetreatments_enum';
import {
  useUpdatePackagetreatment,
  useSinglePackagetreatment,
  useGetDropdownOptions,
} from '../../shared/hooks/UsePackagetreatment';
import { editPackagetreatment } from '../../store/actions/packagetreatment_action';
import { useDispatch } from 'react-redux';
import api from '../../domain/api';
// import { useSelectAllPackagetreatment } from "../../shared/hooks/UsePackagetreatment";

const EditPackagetreatment = ({ match }) => {
  let history = useHistory();
  const [single_data] = useSinglePackagetreatment(match.params.id);
  const [updateData] = useUpdatePackagetreatment();
  const {
    packagetreatment_loading,
    packagetreatment,
    edit_packagetreatment_loading,
  } = single_data;
  const [featuredImage, setFeaturedImage] = useState(null);
  const dispatch = useDispatch();
  const [dropdownOptions, loadOptions] = useGetDropdownOptions();
  const submitFormClicked = async (values) => {
    const data = await convertToFormData({ values, featuredImage });

    // await updateData(packagetreatment._id, data);
    // await dispatch(editPackagetreatment(packagetreatment._id, data));
    await api.put(`/packagetreatments/${packagetreatment._id}`, values);

    history.push(`/${LINK_URL}/${packagetreatment._id}/view`);
  };

  return (
    <div className='pace-done'>
      <div>
        <Header />
        <BreadCrumb
          title={`Edit ${PAGE_SINGLE_TITLE}`}
          mainLinkTitle={PAGE_TITLE}
          mainLinkUrl={LINK_URL}
          activeLink='Edit'
        />
      </div>
      <div className='container-fluid'>
        <div className='col-lg-12'>
          <div className='card'>
            {!packagetreatment_loading ? (
              packagetreatment && (
                <div>
                  <div className='card-header'>
                    <div>
                      <h4 className='card-title'>
                        {packagetreatment[Object.keys(inputFields)[0]]} -{' '}
                        <span>Edit</span>{' '}
                      </h4>
                      <p className='card-title-desc'>
                        <Link
                          to={`/${LINK_URL}`}
                          className='btn btn-soft-light'
                        >
                          <i className='fa fa-angle-left'></i> {PAGE_TITLE}
                        </Link>
                        <Link
                          to={`/${LINK_URL}/${packagetreatment._id}/view`}
                          className='btn btn-soft-light'
                        >
                          <i className='fa fa-eye'></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <PackagetreatmentForm
                    data={packagetreatment}
                    edit={true}
                    featuredImage={featuredImage}
                    setFeaturedImage={setFeaturedImage}
                    submitForm={submitFormClicked}
                    inputFields={inputFields}
                    initialValues={initialValues}
                    dropdown_options={dropdownOptions}
                    loading={edit_packagetreatment_loading}
                    loadOptions={loadOptions}
                  />
                </div>
              )
            ) : (
              <div className='text-center'>
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditPackagetreatment;
